import React from 'react';
import Header from './components/Header';
import AboutProject from './components/AboutProject';
import Media from './components/Media';
import Features from './components/Features';
import BackOnStartups from './components/Footer';
import Contact from './components/Contact';
import { Navbar } from '../layout';
import { Section } from '../common';

export default class DetailPage extends React.Component {
  render() {
    const { project } = this.props;
    const { product, company, features, stories, media, contact } = project;
    const headerProps = { product, company };
    const contactProps = { company, contact };

    return (
      <React.Fragment>
        <Section>
          <Navbar />
        </Section>
        <div>
          <Header {...headerProps} />
          <Features features={features} />
          <AboutProject stories={stories} />
          <Media {...media} />
          <Contact {...contactProps} />
          <BackOnStartups />
        </div>
      </React.Fragment>
    );
  }
}
